import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { clearFeatureFlagsCache, refreshServerFlags } from "@/lib/useFeatureFlags";

const AuthContext = createContext(null);

function persistUser(user) {
  try {
    if (user && user.id) {
      localStorage.setItem("user", JSON.stringify({ id: user.id, email: user.email, role: user.role }));
    } else {
      localStorage.removeItem("user");
    }
  } catch { /* ignore */ }
}

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  const setUser = (u) => { persistUser(u || null); setUserState(u); };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("oscopge_token", data.access_token);
    setUser(data);
    refreshServerFlags();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.access_token) localStorage.setItem("oscopge_token", data.access_token);
    setUser(data);
    refreshServerFlags();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("oscopge_token");
    localStorage.removeItem("user");
    clearFeatureFlagsCache();
    try { window.__OSCOP_FEATURE_FLAGS__ = {}; } catch { /* noop */ }
    setUser(false);
  };

  const refresh = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch { /* ignore */ }
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, setUser, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
